module.exports = __webpack_public_path__ + "static/media/eye.50047e6a.svg";